// extracted by mini-css-extract-plugin
export default {"agreementTitle":"TemplateRow_agreementTitle__wz8oE","text":"TemplateRow_text__fTOus","date":"TemplateRow_date__cE9Wx","box":"TemplateRow_box__7WlPM"};